import { useSourcePage } from '@components/listings-search-bar/adapters/hooks/use-source-page';
import AnalyticsConstants from '@constants/analytics';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useCallback } from 'react';

const SOURCE_CONTENT = 'search_bar_tooltip';

export const useTrackSearchBarTooltip = () => {
	const { track } = useAnalyticsContext();
	const sourcePage = useSourcePage();

	const trackShown = useCallback(() => {
		track({
			event: AnalyticsConstants.WIDGET_VIEWED,
			properties: {
				sourcePage,
				sourceContent: SOURCE_CONTENT,
			},
		});
	}, [track, sourcePage]);

	const trackDismissed = useCallback(() => {
		track({
			event: AnalyticsConstants.WIDGET_CLICKED,
			properties: {
				sourcePage,
				sourceContent: SOURCE_CONTENT,
				action: AnalyticsConstants.DISMISS,
			},
		});
	}, [track, sourcePage]);

	return { trackShown, trackDismissed };
};
